export default __webpack_public_path__ + "static/media/043-magic lamp.1d4d4929.svg";